import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import CurrencyTable from '../packages/currency_table/src/components/CurrencyTable';
import CurrencyConverter from '../packages/currency_converter/src/components/CurrencyConverter';
import CryptoList from '../packages/crypto_list/src/components/CryptoList';

const appDictionary = {
  currency_table: CurrencyTable,
  currency_converter: CurrencyConverter,
  crypto_list: CryptoList
};

const renderApp = () => {
  const currencyApp = document.getElementById('currency-app');

  if (!currencyApp) {
    return;
  }

  const appName = currencyApp.getAttribute('data-app-name');

  if (!appDictionary[appName]) {
    return;
  }

  const defaultCurrency = currencyApp.getAttribute('data-default-currency');
  const language = currencyApp.getAttribute('data-language');

  const App = appDictionary[appName];

  render(
    <AppContainer>
      <App defaultCurrency={defaultCurrency} language={language} />
    </AppContainer>,
    currencyApp
  );
};

renderApp();
